let templateString = require('./control-logo.html');

let skControlLogoController = function() {

}

export let skControlLogo = {
  template: templateString,
      // bindings: {
      //     heading: '<',
      //     subheading: '<',
      //     details: '<',
      //     showWhen: '<',
      //     onOpen: '<',
      //     onClose: '<'
      // },
      // transclude: true, // allow child DOMs to be added
      controller: skControlLogoController
  };

angular.module('skykitProvisioning').component('skControlLogo', skControlLogo);